import React from "react";

const AboutUs = () => {
  return (
    <div className="container py-5">
      {/* ===== HEADER ===== */}
      <div className="text-center mb-5">
        <h1 className="fw-bold">About FreshCart</h1>
        <p className="text-muted mt-2">
          Your trusted online grocery delivery partner
        </p>
      </div>

      {/* ===== INTRO ===== */}
      <div className="row justify-content-center mb-4">
        <div className="col-md-10 text-center">
          <p className="fs-5">
            FreshCart is an online grocery platform designed to make your daily
            shopping easy, fast, and affordable. We deliver fresh fruits,
            vegetables, dairy products, and household essentials directly to
            your doorstep.
          </p>
        </div>
      </div>

      {/* ===== MISSION / VISION ===== */}
      <div className="row text-center mb-5">
        <div className="col-md-6 mb-4">
          <div className="border rounded p-4 h-100 shadow-sm">
            <h4 className="fw-bold mb-3">Our Mission</h4>
            <p>
              To provide high-quality groceries at the best prices with fast and
              reliable delivery, making everyday shopping stress-free for
              everyone.
            </p>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="border rounded p-4 h-100 shadow-sm">
            <h4 className="fw-bold mb-3">Our Vision</h4>
            <p>
              To become the most trusted online grocery platform by focusing on
              customer satisfaction, product quality, and service excellence.
            </p>
          </div>
        </div>
      </div>

      {/* ===== WHY CHOOSE US ===== */}
      <div className="row mb-5">
        <div className="col text-center mb-4">
          <h3 className="fw-bold">Why Choose FreshCart?</h3>
        </div>

        <div className="col-12">
          <div className="row text-center">
            <div className="col-md-3 col-6 mb-4">
              <div className="p-3 border rounded h-100">
                <h5 className="fw-bold">Fresh Products</h5>
                <p className="text-muted mb-0">
                  Carefully selected and quality-checked items.
                </p>
              </div>
            </div>

            <div className="col-md-3 col-6 mb-4">
              <div className="p-3 border rounded h-100">
                <h5 className="fw-bold">Fast Delivery</h5>
                <p className="text-muted mb-0">
                  Quick and reliable doorstep delivery.
                </p>
              </div>
            </div>

            <div className="col-md-3 col-6 mb-4">
              <div className="p-3 border rounded h-100">
                <h5 className="fw-bold">Best Prices</h5>
                <p className="text-muted mb-0">
                  Affordable pricing with great offers.
                </p>
              </div>
            </div>

            <div className="col-md-3 col-6 mb-4">
              <div className="p-3 border rounded h-100">
                <h5 className="fw-bold">Easy Returns</h5>
                <p className="text-muted mb-0">
                  Hassle-free return & refund policy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== FOOTER NOTE ===== */}
      <div className="text-center">
        <p className="text-muted">
          Thank you for choosing <strong>FreshCart</strong>.  
          We look forward to serving you every day!
        </p>
      </div>
    </div>
  );
};

export default AboutUs;